import { deleteApp, initializeApp } from "firebase/app";
import { createUserWithEmailAndPassword, getAuth, type User } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth();
const storage = getStorage(app);

// createUserWithEmailAndPassword autentica automaticamente como el usuario
// recien creado en la instancia de Auth que se le pase. Si se usa la
// instancia principal (`auth`), esto reemplaza la sesion de quien esta
// creando la cuenta (admin creando otro admin o una ruta) por la del usuario
// nuevo, y el logout posterior para "volver" a la sesion original queda
// sujeto a una condicion de carrera con ese cambio de sesion automatico.
// Se crea el usuario en una app secundaria desechable para que la sesion
// principal nunca se vea afectada.
export const crearUsuarioSinAfectarSesionActual = async (
  email: string,
  contrasena: string,
): Promise<User> => {
  const secondaryApp = initializeApp(firebaseConfig, `secondary-${Date.now()}`);

  try {
    const secondaryAuth = getAuth(secondaryApp);
    const { user } = await createUserWithEmailAndPassword(secondaryAuth, email, contrasena);

    return user;
  } finally {
    await deleteApp(secondaryApp);
  }
};

export { app, auth, storage };
